import { createContext } from 'react';

/**
 * Skeleton Context to pass 'animate' to Skeleton.Bones
 */

export const SkeletonContext = createContext({
  animate: true,
});
